import { Component, EventEmitter, Input, Output } from "@angular/core";

export type TagType = "default" | "success" | "warning" | "error" | "info";

@Component({
  selector: "snt-tag-ui",
  template: "",
  standalone: false
})
export class TagComponent {
  @Input()
  title: string | undefined;

  @Input()
  type: TagType | undefined;

  @Input()
  icon: string | undefined;

  @Input()
  image: string | undefined;

  @Input()
  clickable: boolean = false;

  @Output()
  onClick: EventEmitter<void> = new EventEmitter<void>();
}
